import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import mdEntityService from 'core/metamodel/mdEntityService';
import {createForm} from 'core/form/createForm';
import {Validate} from 'core/form/validate';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import Grid from "core/grid/domain/grid";
import {action, observable} from "mobx";
import commonService from "core/common/service/commonService";
import {FormProps} from "core/form/formUtils";
import {observer} from "mobx-react";
import {DialogAncestor, DialogProps} from "core/common/page/dialogAncestor";
import gridService from "core/grid/gridService";
import {MultiUpdateDto, MultiUpdateField} from "core/grid/component/multiUpdateDialog";
import {ShipmentRepackaging} from "shipment/shipmentDomain";
import StyledDatePicker from "core/components/fields/styledDatePicker";
import {isString} from "util";
import {loc} from "core/common/config/locales";
import moment from "moment";



/* ************************************************************************************************
 * ***********   DIALOG  *************************************************************
 * ********************************************************************************************** */

@observer
export class ShipmentRepackagingUpdateDialog extends DialogAncestor<DialogProps, undefined, string> {


  private grid: Grid;
  @observable shipmentRepackaging: ShipmentRepackaging;

  @action open(resolve: any, reject: any, grid: Grid) {

    let gridParams = grid.createFullParams();
    console.log('ShipmentRepackagingUpdateDialog: Opening dialog for gridParams', gridParams);

    this.shipmentRepackaging = new ShipmentRepackaging({$new: true, repackedDate:  moment().millisecond(0).toDate()});
    this.resolve = resolve;
    this.reject = reject;
    this.dialogOpen = true;
    this.grid = grid;
    this.$errors = [];
  }


  @action ok = () => {
    let shipmentRepackagingEntity = mdEntityService.getEntity("ShipmentRepackaging");

    if (this.shipmentRepackaging.repackedDate) {
      if (isString(this.shipmentRepackaging.repackedDate)) this.shipmentRepackaging.repackedDate = new Date(this.shipmentRepackaging.repackedDate as string);
      (this.shipmentRepackaging.repackedDate as Date).setMilliseconds(0);
    }

    let multiUpdateDto = MultiUpdateDto.newInstance(this.grid.$entityRef, [
      new MultiUpdateField(shipmentRepackagingEntity, this.shipmentRepackaging.repackedDate, "repackedDate")
    ], this.grid.createFullParams());
    multiUpdateDto.customName = "ShipmentRepackagingUpdateDialog";

    this.$errors = [];

    let form = this.shipmentRepackaging.getForm("ShipmentRepackagingUpdateFieldForm");
    form.validateForm(this.shipmentRepackaging, this.$errors);

    if (!this.$errors.length) {

      commonService.loading(true);
      gridService.multiUpdate(multiUpdateDto)
        .then((mud: MultiUpdateDto) => {
          commonService.loading(false);
          this.dialogOpen = false;
          this.resolve("OK");
          commonService.notifySuccess(`Bylo aktualizováno ${mud.count}  záznamů`);
        }, error => {
          this.$errors = error.getMessages();
        });

    }
  };

  @action cancel = () => {
    this.dialogOpen = false;
    this.reject("cancel");
  };


  render() {

    if (!(this.dialogOpen)) return null;

    console.log('ShipmentRepackagingUpdateDialog: rendering dialog');


    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={this.cancel}
      />,
      <FlatButton
        label="Update"
        secondary
        onClick={this.ok}
      />,
    ];

    return (
      <Dialog
        title={loc.i18n`Advance ${this.grid.getSelectedCount()} repackagings`}
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        contentStyle={{width: '60%', maxWidth: 'none'}}
        bodyStyle={{overflow: 'visible'}}
      >

        <ErrorComp messages={this.$errors}/>

        <ShipmentRepackagingUpdateFieldForm entities={mdEntityService.entityMap} entity={mdEntityService.getEntity("ShipmentRepackaging")} dataObject={this.shipmentRepackaging} rootObject={this.shipmentRepackaging}/>
      </Dialog>
    );
  }

}


/* ************************************************************************************************
 * ***********   FORM  *************************************************************
 * ********************************************************************************************** */



@createForm({
  formName: 'ShipmentRepackagingUpdateFieldForm',
  fields: [{
    name: 'repackedDate',
    validators: ['IsRequired']
  }]
}, () => <noscript/>)
@observer
class ShipmentRepackagingUpdateFieldForm extends React.Component<FormProps<ShipmentRepackaging, ShipmentRepackaging>> {


  render() {

    let {dataObject, rootObject, entities, index, form} = this.props;
    let {repackedDate} = form.fields;


    return (

      <div>
          <div>
            <StyledDatePicker {...repackedDate.props} time/>
            <Validate field={repackedDate} value={repackedDate.props.value} />
          </div>

      </div>
    );
  }



}



// WEBPACK FOOTER //
// ./src/shipment/component/shipmentRepackagingUpdateDialog.tsx